import React from 'react';
import styles from './ActorCard.module.css';

/**
 * @component ActorCardMeta
 * @description 성별 · 나이 · 키 가로 인라인 배치
 *
 * @param {string} props.gender  - 성별 ('남성' | '여성')
 * @param {number} props.age     - 나이
 * @param {number} props.height  - 키 (cm)
 */
function ActorCardMeta({ gender, age, height }) {
  const items = [gender, `${age}세`, `${height}cm`];

  return (
    <div className={styles.meta}>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <span className={styles.metaItem}>{item}</span>
          {index < items.length - 1 && (
            <span className={styles.metaDivider} aria-hidden="true" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

export default ActorCardMeta;
